module.exports = __webpack_public_path__ + "static/media/sliced_pickled_cucumbers.ef00a3f2.png";